import { Injectable, OnDestroy, Optional } from '@angular/core';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { Logger } from '@mydocma/common/src/lib/logger';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CoStructureSyncService, StructureSyncError, StructureSyncErrorKind } from './co-structure-sync.service';

@Injectable()
export class CoStructureSyncViewService implements OnDestroy {

  private readonly subscription = new Subscription();

  constructor(
    private readonly syncService: CoStructureSyncService,
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
    @Optional() private readonly logger: Logger | null,
  ) {
    this.subscription.add(
      this.syncService.errors$.subscribe(error => this.handleError(error))
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private handleError(error: StructureSyncError): void {
    const message = this.buildMessage(error);
    const detail = `${error.kind} ${error.reason ?? ''} ${JSON.stringify(error.info)}`;
    if (this.logger) {
      this.logger.error(detail, '', 'CoStructureSyncViewService');
    } else {
      console.error('[CO-SYNC]', detail);
    }
    this.notificationService.error(message);
  }

  private buildMessage(error: StructureSyncError): string {
    if (error.kind === StructureSyncErrorKind.BackendFailed && error.reason) {
      return this.translateService.instant('CO.projectStructure.treeSync.failedWithReason', { reason: error.reason });
    }
    if (error.kind === StructureSyncErrorKind.BackendFailed) {
      return this.translateService.instant('CO.projectStructure.treeSync.failedGeneric');
    }
    return this.translateService.instant('CO.projectStructure.treeSync.resolutionFailed');
  }
}
